export default __webpack_public_path__ + "static/media/ic_slingshot.4b95aa77.svg";